module.exports = __webpack_public_path__ + "img/true.68b44f5e.jpg";